module.exports = __webpack_public_path__ + "img/5-5.25db9ae7.svg";